import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { InputSelectComponent } from "../../../../../shared/input-select/input-select.component";
import { TrialDetail } from "../../../../../core/models/trial-detail.model";
import { Cultures } from "../../../../../core/constants/cultures";
import { FormControl, FormGroup } from "@angular/forms";
import { TrialSupportInfoTranslation } from "../../../../../core/models/trial-support-info-translation.model";
import { TrialService } from "../../../../../core/services/trial.service";
import { AlertService } from "../../../../../shared/alert/alert.service";

@Component({
  selector: 'app-trial-support-info',
  templateUrl: './trial-support-info.component.html',
  styleUrl: './trial-support-info.component.scss'
})
export class TrialSupportInfoComponent implements OnInit {
  @ViewChild('cultureSelect') cultureSelect: InputSelectComponent;

  @Input() trial: TrialDetail;

  @Output() hasChanged = new EventEmitter<boolean>(false);

  supportForm: FormGroup = new FormGroup({
    selectedCulture: new FormControl<string>('en'),
    isBusy: new FormControl<boolean>(false),
  });
  infoForms: FormGroup[] = [];

  availableCultures: { value: string, text: string }[] = [];
  supportInfoFilteredCultures: { value: string, text: string }[] = [];
  hasChanges: boolean = false;

  constructor(private _trialService: TrialService, private _alertService: AlertService) {
    Cultures.all().forEach(culture => {
      this.availableCultures.push({ value: culture.culture, text: culture.name });
    });
    this.supportInfoFilteredCultures = this.availableCultures;
  }

  ngOnInit() {
    this.buildInfoForms();
  }

  buildInfoForms() {
    this.hasChanges = false;
    this.hasChanged.emit(false);

    if (!this.trial.supportInfoTranslations)
      this.trial.supportInfoTranslations = [];

    this.infoForms = [];
    this.availableCultures.forEach(culture => {
      const translation = this.trial.supportInfoTranslations.find(t => t.culture === culture.value);
      this.infoForms.push(new FormGroup({
        id: new FormControl<string>(translation?.id),
        culture: new FormControl<string>(culture.value),
        text: new FormControl<string>(translation?.text),
        globalLinkSupportText: new FormControl<string>(translation?.globalLinkSupportText),
        countryLinkSupportText: new FormControl<string>(translation?.countryLinkSupportText)
      }));
    });

    // Add listeners to each form
    this.infoForms.forEach(form => {
      form.valueChanges.subscribe(value => {
        this.hasChanges = true;
        this.hasChanged.emit(this.hasChanges);
        console.log('Form ' + form.get('culture').value + ' has changed');
      });
    });
  }

  onSupportInfoCultureFiltered(value: string) {
    // Trim the input value and convert it to lowercase for case-insensitive filtering
    const filterValue = value.trim().toLowerCase();

    this.supportInfoFilteredCultures = this.availableCultures.filter(x =>
      x.text.toLowerCase().includes(filterValue)
    );
  }

  saveSupportInfo() {
    this.supportForm.patchValue({isBusy: true});

    this.infoForms.forEach(form => {
      const translation = this.trial.supportInfoTranslations.find(x => x.culture == form.value.culture);
      if (!translation) {
        this.trial.supportInfoTranslations.push(new TrialSupportInfoTranslation({
          culture: form.value.culture,
          text: form.value.text,
          globalLinkSupportText: form.value.globalLinkSupportText,
          countryLinkSupportText: form.value.countryLinkSupportText,
        }));
      } else {
        translation.text = form.value.text;
        translation.globalLinkSupportText = form.value.globalLinkSupportText;
        translation.countryLinkSupportText = form.value.countryLinkSupportText;
      }
    });

    this._trialService.updateSupportInformation(this.trial.id, this.trial.supportInfoTranslations).subscribe({
      next: updatedTranslations => {
        // Update the local copy of translations based on the updated response and rebuild the form
        this.trial.supportInfoTranslations = updatedTranslations;
        this.buildInfoForms();

        this.supportForm.patchValue({isBusy: false});
        this.hasChanges = false;
        this.hasChanged.emit(false);

        this._alertService.showSuccessAlert("Support information has been saved successfully.");
      },
      error: err => {
        this.supportForm.patchValue({isBusy: false});
        this._alertService.showErrorResponse(err);
      }
    });
  }
}
